import React from "react";
import styled from "styled-components";

const Date = ({ dateString }) => {
  return (
    <StyledDate>{dateString}</StyledDate>
  );
};

export default Date;

const StyledDate = styled.time`
  font-family: var(--font-sans);
  font-weight: var(--font-caption-weight);
  font-size: 0.75em;
  color: var(--theme-text-against-dark-medium);
`;